import { SurveyResponse } from "src/components/survey/SurveyFormModel";
import { Pair } from "src/components/survey/ApplicationIdentity/model/utils";
import { DisplayLabels } from "src/components/survey/AccessControl/section/util";
import React from "react";
import { TEST_IDS } from "shared/fields";
import { Box } from "@amzn/awsui-components-react-v3";

export const taskId = (application: SurveyResponse): Pair => ({
    label: DisplayLabels.TASK_ID,
    testId: TEST_IDS.ACCESS_CONTROL_SECTION.TASK_ID,
    value: application.appInfo.review.taskId || <Box variant="span">&mdash;</Box>,
});
